<template>
  <div class="doctorGradeDetails">
    <div class="doctorGrades scrollbar">
      <div class="gradesNav">
        <div class="gradesNavL">
          <!-- v-if="index == 0 ? doctor : img" -->
          <a
            href="javascript:;"
            v-for="(item, index) in grade"
            :key="index"
            :class="index == gradeIndex ? 'active' : ''"
            @click="tabNav(index, item.type)"
          >
            {{ item.name }}{{ computedScore(item.type) }}
          </a>
        </div>
        <!-- <div class="gradesNavR">
          <template>
            <span v-if="doctor && doctorQCReport != null" class="marr15">报告：{{ totalScore.ReportScore }}</span>
            <span v-if="img && doctorQCImg != null">影像：{{ totalScore.ImageScore }}</span>
          </template>
        </div> -->
      </div>
      <div class="gradesCC" :style="{ height: height + 'px' }">
        <!-- 报告评分 -->
        <div v-if="gradeType == 'report'">
          <div class="title">
            <span :style="qcresultsShow ? 'margin-left: 90px;' : 'margin-left: 0;'">报告质量要求</span>
            <el-button
              v-if="totalScore.CanReportAppeal"
              class="img-btm qcresultsSelect marr8"
              type="primary"
              size="mini"
              label="rtl"
              @click="appealLaunch('report', 'launch')"
            >
              发起申诉
            </el-button>
            <el-button
              v-if="totalScore.IsShowReportAppealBtn"
              class="img-btm qcresultsSelect marr8"
              type="primary"
              size="small"
              @click="appealDetails('report', 'details')"
            >
              查看申诉
            </el-button>
            <el-select
              v-if="qcresultsShow"
              size="mini"
              class="qcresultsSelect"
              v-model="qcresultsList.Name"
              placeholder="请选择专家"
              @change="qcresultsChange"
            >
              <el-option
                v-for="item in qcresultsByTaskList"
                :key="item.ExpertId"
                :label="item.Name"
                :value="item.Name"
              ></el-option>
            </el-select>
          </div>
          <div class="content">
            <div :style="{ height: height - 67 + 'px' }" class="flowAuto">
              <el-collapse v-model="activeNames">
                <el-collapse-item
                  title="严重扣分项"
                  name="1"
                  v-show="reportSpecialSIList && reportSpecialSIList.length > 0"
                >
                  <div class="flowAuto" :style="{ maxHeight: height - 123 + 'px' }">
                    <div class="gradesCCs qcFrom">
                      <div class="gradesCCsTop marb12">
                        请选择严重扣分项原因（选择任一选项得0分)
                      </div>
                      <div v-for="(item, index) in reportSpecialSIList" :key="item.ScoreItemGuid">
                        <el-checkbox
                          v-model="checkList"
                          @change="checkboxChange($event, index, 'report')"
                          :label="item"
                          class="marb10 block"
                          :disabled="isSeriousSubmint.flag"
                        >
                          {{ item.Description || "" }}
                        </el-checkbox>
                        <div class="gradesSelest" v-if="ischecked[index]">
                          <el-input
                            v-model="item.Note"
                            type="textarea"
                            @blur="remarkBlur(item, index, 'report')"
                            :readonly="isSeriousSubmint.flag"
                            :class="item.notFilledIn ? 'bgImgSet' : ''"
                            placeholder="请输入扣分原因"
                          ></el-input>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-collapse-item>
                <el-collapse-item title="基本扣分项" name="2">
                  <div class="flowAuto" :style="{ maxHeight: height - 123 + 'px' }">
                    <doctor-grade-list :obj="doctorQCReport" @changeActiveNames="changeActiveNames" />
                    <div class="gradesRemark">
                      <el-form ref="form" class="gradesRemarkForm qcFrom">
                        <el-form-item label="备注">
                          <el-input
                            :readonly="isSubmint"
                            type="textarea"
                            v-model="remark.report"
                            placeholder="请输入内容"
                          ></el-input>
                        </el-form-item>
                        <el-form-item label="印象分">
                          <el-input
                            :readonly="isSubmint"
                            v-model.number="remark.reportNum"
                            placeholder="请输入印象分"
                            class="impression"
                          ></el-input>
                        </el-form-item>
                      </el-form>
                    </div>
                  </div>
                </el-collapse-item>
              </el-collapse>
              <div class="submit" v-if="!isSeriousSubmint.flag">
                <el-button @click="saveTmp" type="primary" size="small">保存</el-button>
                <el-button @click="createQC" type="success" size="small">提交</el-button>
              </div>
            </div>
          </div>
        </div>
        <!-- 影像评分 -->
        <div v-if="gradeType == 'img'">
          <div class="title">
            <span>影像诊断质量要求</span>
            <el-button
              v-if="totalScore.CanImageAppeal"
              class="img-btm qcresultsSelect"
              type="primary"
              size="small"
              label="rtl"
              @click="appealLaunch('img', 'launch')"
            >
              发起申诉
            </el-button>
            <el-button
              v-if="totalScore.IsShowImageAppealBtn"
              class="img-btm qcresultsSelect"
              type="primary"
              size="small"
              label="rtl"
              @click="appealDetails('img', 'see')"
            >
              查看申诉
            </el-button>
          </div>
          <div class="content">
            <div :style="{ height: height - 67 + 'px' }" class="flowAuto">
              <el-collapse v-model="activeNames">
                <el-collapse-item
                  title="严重扣分项"
                  name="1"
                  v-show="imageSpecialSIList && imageSpecialSIList.length > 0"
                >
                  <div class="flowAuto" :style="{ maxHeight: height - 123 + 'px' }">
                    <div class="gradesCCs qcFrom">
                      <div class="gradesCCsTop marb12">
                        请选择严重扣分项原因（选择任一选项得0分)
                      </div>
                      <div v-for="(item, index) in imageSpecialSIList" :key="item.ScoreItemGuid">
                        <el-checkbox
                          v-model="imgcheckList"
                          @change="checkboxChange($event, index, 'img')"
                          :label="item"
                          class="marb10 block"
                          :disabled="isSeriousSubmint.flag"
                        >
                          {{ item.Description || "" }}
                        </el-checkbox>
                        <div class="gradesSelest" v-if="imgischecked[index]">
                          <el-input
                            v-model="item.Note"
                            type="textarea"
                            @blur="remarkBlur(item, index, 'img')"
                            :readonly="isSeriousSubmint.flag"
                            :class="item.notFilledIn ? 'bgImgSet' : ''"
                            placeholder="请输入扣分原因"
                          ></el-input>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-collapse-item>
                <el-collapse-item title="基本扣分项" name="2">
                  <div class="flowAuto" :style="{ maxHeight: height - 123 + 'px' }">
                    <doctor-grade-list :obj="doctorQCImg" @changeActiveNames="changeActiveNames" />
                    <div class="gradesRemark">
                      <el-form ref="form" class="gradesRemarkForm qcFrom">
                        <el-form-item label="备注">
                          <el-input
                            :readonly="isSubmint"
                            type="textarea"
                            v-model="remark.img"
                            placeholder="请输入内容"
                          ></el-input>
                        </el-form-item>
                        <el-form-item label="印象分">
                          <el-input
                            :readonly="isSubmint"
                            v-model.number="remark.imgNum"
                            placeholder="请输入印象分"
                            class="impression"
                          ></el-input>
                        </el-form-item>
                      </el-form>
                    </div>
                  </div>
                </el-collapse-item>
              </el-collapse>
              <div class="submit" v-if="!isSeriousSubmint.flag">
                <el-button @click="saveTmp" type="primary" size="small">保存</el-button>
                <el-button @click="createQC" type="success" size="small">提交</el-button>
              </div>
            </div>
          </div>
          <!-- <div class="content" :style="{ height: height - 67 + 'px' }">
						<doctor-grade-list :obj="doctorQCImg" />
						<div class="gradesRemark">
							<el-form ref="form" class="gradesRemarkForm qcFrom">
								<el-form-item label="备注">
									<el-input :readonly="isSubmint" type="textarea" v-model="remark.img"
										placeholder="请输入内容"></el-input>
								</el-form-item>
								<el-form-item label="印象分">
									<el-input :readonly="isSubmint" v-model.number="remark.imgNum" placeholder="请输入印象分"
										class="impression"></el-input>
								</el-form-item>
							</el-form>
						</div>
						<div class="submit" v-if="!isSubmint">
							<el-button @click="saveTmp" type="primary" size="small">保存</el-button>
							<el-button @click="createQC" type="success" size="small">提交</el-button>
						</div>
					</div> -->
        </div>
        <!-- 病史评分 -->
        <div v-if="gradeType == 'history'">
          <div class="title">
            <span>病史评分</span>
          </div>
          <div class="content">
            <div :style="{ height: height - 67 + 'px' }" class="flowAuto">
              <el-collapse v-model="activeNames">
                <el-collapse-item
                  title="严重扣分项"
                  name="1"
                  v-show="historySpecialSIList && historySpecialSIList.length > 0"
                >
                  <div class="flowAuto" :style="{ maxHeight: height - 123 + 'px' }">
                    <div class="gradesCCs qcFrom">
                      <div class="gradesCCsTop marb12">
                        请选择严重扣分项原因（选择任一选项得0分)
                      </div>
                      <div v-for="(item, index) in historySpecialSIList" :key="item.ScoreItemGuid">
                        <el-checkbox
                          v-model="historycheckList"
                          @change="checkboxChange($event, index, 'history')"
                          :label="item"
                          class="marb10 block"
                          :disabled="isSeriousSubmint.flag"
                        >
                          {{ item.Description || "" }}
                        </el-checkbox>
                        <div class="gradesSelest" v-if="ischeckedhistory[index]">
                          <el-input
                            v-model="item.Note"
                            type="textarea"
                            @blur="remarkBlur(item, index, 'history')"
                            :readonly="isSeriousSubmint.flag"
                            :class="item.notFilledIn ? 'bgImgSet' : ''"
                            placeholder="请输入扣分原因"
                          ></el-input>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-collapse-item>
                <el-collapse-item title="基本扣分项" name="2">
                  <div class="flowAuto" :style="{ maxHeight: height - 123 + 'px' }">
                    <doctor-grade-list :obj="doctorQCHistory" @changeActiveNames="changeActiveNames" />
                    <div class="gradesRemark">
                      <el-form ref="form" class="gradesRemarkForm qcFrom">
                        <el-form-item label="备注">
                          <el-input
                            :readonly="isSubmint"
                            type="textarea"
                            v-model="remark.history"
                            placeholder="请输入内容"
                          ></el-input>
                        </el-form-item>
                        <el-form-item label="印象分">
                          <el-input
                            :readonly="isSubmint"
                            v-model.number="remark.historyNum"
                            placeholder="请输入印象分"
                            class="impression"
                          ></el-input>
                        </el-form-item>
                      </el-form>
                    </div>
                  </div>
                </el-collapse-item>
              </el-collapse>
              <div class="submit" v-if="!isSeriousSubmint.flag">
                <el-button @click="saveTmp" type="primary" size="small">保存</el-button>
                <el-button @click="createQC" type="success" size="small">提交</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-drawer
        :style="{ width: width }"
        :visible.sync="drawer"
        :direction="direction"
        :append-to-body="true"
        :modal="false"
        :wrapperClosable="false"
        :size="width"
        :with-header="false"
        v-loading="localLoading"
      >
        <div>
          <el-button type="primary" class="closeBtn" size="mini" round @click="handleClose">
            关闭
            <i class="el-icon-close el-icon--right"></i>
          </el-button>
          <div
            class="title marb25"
            v-if="gradeType == 'report' ? totalScore.IsShowReportAppealBtn : totalScore.IsShowImageAppealBtn"
          >
            申诉进度
          </div>
          <div
            class="block"
            v-if="gradeType == 'report' ? totalScore.IsShowReportAppealBtn : totalScore.IsShowImageAppealBtn"
          >
            <el-timeline>
              <el-timeline-item
                v-for="(activity, index) in appealDetail.StatusList"
                :key="index"
                :icon="activity.icon"
                :color="activity.DateTime == '' ? '' : '#248AFD'"
                size="large"
                :timestamp="activity.Name"
                placement="top"
              >
                <div class="fz12 silver">{{ activity.DateTime }}</div>
                <div class="pab6">{{ activity.Discription }}</div>
              </el-timeline-item>
            </el-timeline>
            <div class="dividingLine"></div>
          </div>
          <div class="title marb25" v-if="appealList && appealList.length > 0">申诉内容</div>
          <div
            v-for="(item, index) in appealList"
            :key="index"
            class="appealItem"
            v-if="gradeType == 'report' ? totalScore.CanReportAppeal : totalScore.CanImageAppeal"
          >
            <div class="marb18">
              <el-checkbox v-model="item.checked"></el-checkbox>
              <div class="text description marl5">{{ item.Description }}</div>
              <div class="text pointDeduction rt">扣分:{{ item.Score }}</div>
            </div>
            <div class="marb25">
              <el-input
                type="textarea"
                :class="item.notFilledIn ? 'textarea marb18 bgImgSet' : 'textarea marb18'"
                @input="$forceUpdate()"
                @blur="noteBlurs(item, index)"
                v-model="item.desc"
                placeholder="请输入申诉原因"
              ></el-input>
              <el-upload
                class="upload-demo marb18"
                action="#"
                accept="image/jpeg,image/png,image/gif,image/jpg"
                :show-file-list="false"
                :limit="10"
                :auto-upload="false"
                :before-upload="beforeAvatarUpload"
                :on-change="getFile"
                :on-error="handleError"
              >
                <el-button size="small" type="primary" @click="getappealIndex(index)">上传图片</el-button>
              </el-upload>
              <ul class="imgList">
                <li v-for="(imgitem, imgindex) in item.imageList" :key="imgindex" class="marr15">
                  <div class="deleteImg" @click="deleteImg(index, imgindex)">
                    <i class="iconfont el-icon-close"></i>
                  </div>
                  <img class="drawerImg" @click="handlePictureCardPreview(imgitem)" :src="imgitem" alt="" />
                </li>
              </ul>
            </div>
            <div class="dividingLine"></div>
          </div>
          <div v-if="(role.contain('技师') || role.contain('医生')) && appealDetail.AppealStatus <= 146">
            <div class="title">
              申诉理由
              <span class="marl10" v-if="appealDetail && appealDetail.Details">
                (共{{ appealDetail.Details.length }}项)
              </span>
            </div>
            <div v-for="(item, index) in appealDetail.Details" :key="index" class="appealContentbox mart25">
              <div class="marb10 appealContentTitle">
                <div class="appealSerialNumber marr10">{{ index + 1 }}</div>
                <div class="text description">{{ item.Description }}</div>
                <div class="text pointDeduction rt marr15">扣分:{{ item.RawScore }}</div>
              </div>
              <div class="pd15">
                <span class="fz14">{{ item.Request }}</span>
                <ul class="imgList mart10">
                  <li v-for="(items, indexs) in item.RequestPicUrls" :key="indexs" class="marr15">
                    <img class="drawerImg" @click="handlePictureCardPreview(items)" :src="items" alt="" />
                  </li>
                </ul>
                <div></div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="title" v-if="isShowTitle">
              申诉内容
              <span class="marl10" v-if="appealDetail && appealDetail.Details">
                (共{{ appealDetail.Details.length }}项)
              </span>
            </div>
            <div v-for="(item, index) in appealDetail.Details" :key="index" class="appealContentbox mart25">
              <div class="appealContentTitle">
                <div class="appealSerialNumber marr10">{{ index + 1 }}</div>
                <div class="text description">{{ item.Description }}</div>
                <div class="text pointDeduction rt marr15">
                  原始扣分:{{ item.RawScore }}
                  <el-button
                    size="mini"
                    type="primary"
                    class="marl10"
                    v-if="!appealDetail.IsSpecial && item.IsBtnShow && modifyShow"
                    @click="item.Ismodify = !item.Ismodify"
                  >
                    修改
                  </el-button>
                </div>
              </div>
              <div>
                <div class="marb25 pd15">
                  <div class="title marb10">
                    <svg class="icon fz18 wh18" aria-hidden="true">
                      <use xlink:href="#iconappeal"></use>
                    </svg>
                    申诉理由
                  </div>
                  <div class="silver">
                    <span class="fz14">{{ item.Request }}</span>
                    <ul class="imgList mart10">
                      <li v-for="(items, indexs) in item.RequestPicUrls" :key="indexs" class="marr15">
                        <img class="drawerImg" @click="handlePictureCardPreview(items)" :src="items" alt="" />
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="result">
                  <div class="title marb18">
                    <svg class="icon fz18 wh18" aria-hidden="true">
                      <use xlink:href="#iconfeedback"></use>
                    </svg>
                    反馈结果
                    <span style="float: right;">
                      <el-button
                        size="mini"
                        type="primary"
                        class="marl10"
                        v-if="appealDetail.IsSpecial && !appealDetail.HasRescored"
                        @click="specialClick"
                      >
                        修改
                      </el-button>
                      <el-button
                        v-if="appealDetail.HasRescored"
                        size="mini"
                        type="primary"
                        class="marl10"
                        @click="lookClick"
                      >
                        查看
                      </el-button>
                    </span>
                  </div>
                  <div class="silver">
                    <div class="marb18 gradesCCs editCard" v-if="item.Ismodify">
                      <div class="marb10">
                        <div class="text description">{{ item.Description }}:</div>
                        <div class="text pointDeduction rt">修改扣分:{{ item.ManagerScore }}</div>
                      </div>
                      <el-checkbox-group
                        v-if="item.Options && item.Options.length > 0 && !item.IsNoteShow"
                        v-model="item.ManagerOptionGuid"
                        @change="compentedScore"
                        size="mini"
                        class="gradesSelest block"
                      >
                        <!-- <el-radio v-for="(item, optionindex) in item.Options" :key="optionindex"
													:label="item.Score" :disabled="!modifyShow"
													@change="radioClick(index, optionindex, item)">
													<template v-if="item.Remark">
														{{ item.Description }}({{ item.Score }}) : {{ item.Remark }}
													</template>
													<template v-else>
														{{ item.Description }}({{ item.Score }})
													</template>
												</el-radio> -->
                        <el-checkbox-button
                          class="btnMar"
                          v-for="(items, optionindex) in item.Options"
                          :key="optionindex"
                          :label="items.OptionGuid"
                          :disabled="!modifyShow"
                          @change="radioClick(index, optionindex, items, item)"
                        >
                          <template v-if="items.Remark">
                            <el-tooltip :content="items.Remark" placement="top" popper-class="atooltip" effect="dark">
                              <span>{{ items.Description }}({{ items.Score }})</span>
                            </el-tooltip>
                          </template>
                          <template v-else>{{ items.Description }}({{ items.Score }})</template>
                        </el-checkbox-button>
                      </el-checkbox-group>
                    </div>
                    <div>
                      <span class="fz14" v-if="!modifyShow">{{ item.ManagerResponse }}</span>
                      <el-input
                        type="textarea"
                        :class="item.notFilledIn ? 'textarea marb18 bgImgSet mart10' : 'textarea marb18 mart10'"
                        @input="$forceUpdate()"
                        @blur="detilnoteBlurs(item, index)"
                        v-model="item.ManagerResponse"
                        placeholder="请输入回应内容"
                        v-else
                      ></el-input>
                      <ul class="imgList mart10" v-if="!modifyShow">
                        <li v-for="(items, indexs) in item.ManagerResponsePicUrls" :key="indexs" class="marr15">
                          <img class="drawerImg" @click="handlePictureCardPreview(items)" :src="items" alt="" />
                        </li>
                      </ul>
                      <div v-else>
                        <el-upload
                          class="upload-demo marb18"
                          action="#"
                          accept="image/jpeg,image/png,image/gif,image/jpg"
                          :show-file-list="false"
                          :limit="10"
                          :auto-upload="false"
                          :before-upload="beforeAvatarUpload"
                          :on-change="getFile"
                          :on-error="handleError"
                        >
                          <el-button size="small" type="primary" @click="getappealIndex(index, 'detail')">
                            上传图片
                          </el-button>
                        </el-upload>
                        <ul class="imgList">
                          <li v-for="(imgitem, imgindex) in item.imageList" :key="imgindex" class="marr15">
                            <div class="deleteImg" @click="detildeleteImg(index, imgindex)">
                              <i class="iconfont el-icon-close"></i>
                            </div>
                            <img class="drawerImg" @click="handlePictureCardPreview(imgitem)" :src="imgitem" alt="" />
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-drawer>
      <div class="submitBtn center" :style="{ width: width }" v-if="drawer">
        <div v-if="role.contain('仲裁专家')">
          <el-button v-if="appealDetail.AppealStatus == 144" size="small" type="primary" @click="expertRespond()">
            回应
          </el-button>
          <el-button v-else-if="appealDetail.AppealStatus == 146"></el-button>
        </div>
        <div v-if="role.contain('仲裁管理')">
          <el-button v-if="appealDetail.AppealStatus == 142" size="small" type="primary" @click="respond('direct')">
            回应
          </el-button>
          <el-button v-if="appealDetail.AppealStatus == 142" size="small" type="primary" @click="forward()">
            转发
          </el-button>
          <el-button v-if="appealDetail.AppealStatus == 146" size="small" type="primary" @click="respond('toexamine')">
            审核
          </el-button>
        </div>
        <div v-if="role.contain('医生') || role.contain('技师')">
          <el-button v-if="appealDetail.AppealStatus == 146"></el-button>
          <el-button v-else-if="appealDetail.AppealStatus == 142" size="small" type="primary" @click="withdraw()">
            取消申诉
          </el-button>
          <el-button v-else-if="appealDetail.CanAdmit" size="small" type="primary" @click="determine()">
            确认无异议
          </el-button>
          <el-button v-else-if="appealDetail.AppealStatus >= 148 || appealDetail.AppealStatus == 144"></el-button>
          <el-button v-else size="small" type="primary" @click="subBtn()">提交申诉</el-button>
        </div>
      </div>
      <el-dialog :visible.sync="dialogVisible"><img width="100%" :src="dialogImageUrl" alt="" /></el-dialog>
    </div>
    <el-dialog
      title="仲裁专家列表"
      :visible.sync="dialogexpert"
      width="80%"
      :close-on-click-modal="false"
      class="scrollbar exportFrom dialogFrom"
    >
      <div class="dialogSearch">
        <div>
          <el-form ref="form" label-width="85px" :model="appealExpertListParameter" class="qcFrom disflex">
            <el-form-item label="关键词" prop="keyword">
              <el-input
                v-model="appealExpertListParameter.Keyword"
                class="name"
                size="mini"
                placeholder="姓名/手机号"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="search">查询</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <el-table class="qcTable scrollbar" :data="appealExpertList.Experts" ref="multipleTable" max-height="350">
        <el-table-column prop="Name" label="专家姓名" width="100"></el-table-column>
        <el-table-column prop="LoginId" label="手机号" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.LoginId == ' '">—</span>
            <span v-else>{{ scope.row.LoginId }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ExpertFromType" label="专家来源">
          <template slot-scope="scope">
            <span v-show="scope.row.ExpertFromType == 0">未知</span>
            <span v-show="scope.row.ExpertFromType == 1">专委会</span>
            <span v-show="scope.row.ExpertFromType == 2">集团外</span>
            <span v-show="scope.row.ExpertFromType == 3">集团内</span>
          </template>
        </el-table-column>
        <el-table-column prop="ExpertLevelType" label="专家分组">
          <template slot-scope="scope">
            <span v-if="scope.row.ExpertLevelType == 0">—</span>
            <span v-else>{{ scope.row.ExpertLevelType }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ExpertMajor" label="专家专业">
          <template slot-scope="scope">
            <span v-show="scope.row.ExpertMajor == 0">未知</span>
            <span v-show="scope.row.ExpertMajor == 1">超声</span>
            <span v-show="scope.row.ExpertMajor == 2">放射</span>
            <span v-show="scope.row.ExpertMajor == 3">核医学</span>
          </template>
        </el-table-column>
        <el-table-column prop="ModalityTypes" label="擅长设备">
          <template slot-scope="scope">
            <span v-if="scope.row.ModalityTypes == null">—</span>
            <span v-else>{{ scope.row.ModalityTypes }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="BodyParts" label="擅长部位">
          <template slot-scope="scope">
            <span v-if="scope.row.BodyParts == null">—</span>
            <span v-else>{{ scope.row.BodyParts }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="Title" label="专家职称">
          <template slot-scope="scope">
            <span v-if="scope.row.Title == null">—</span>
            <span v-else>{{ scope.row.Title }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="操作" fixed="right">
          <template slot-scope="scope">
            <span class="tableOpe" @click="choice(scope.row)">选择</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pages">
        <el-pagination
          class="pageAll"
          align="center"
          layout="prev, pager, next"
          :total="appealExpertList.TotalCount"
          :page-size="appealExpertListParameter.pageCount"
          :current-page="appealExpertListParameter.pageIndex"
          @current-change="currentChange"
        ></el-pagination>
      </div>
    </el-dialog>
    <el-dialog title="确认提示" :visible.sync="dialogchoice" width="30%" center>
      <span class="colwhite">您确定将这份申诉报告转发给{{ expertRow.Name }}仲裁专家仲裁吗?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogchoiceClick(true)">取 消</el-button>
        <el-button type="primary" @click="dialogchoiceClick(false)">确 定</el-button>
      </span>
    </el-dialog>
    <el-drawer
      :visible.sync="specialDrawer"
      :style="{ width: width }"
      :direction="direction"
      :append-to-body="true"
      :modal="false"
      :wrapperClosable="false"
      :size="width"
      :with-header="false"
      class="appealDrawer"
      v-loading="appealLoading"
    >
      <div>
        <el-button type="primary" class="closeBtn" size="mini" round @click="specialDrawer = !specialDrawer">
          关闭
          <i class="el-icon-close el-icon--right"></i>
        </el-button>
        <div class="title marb25">
          申诉评分
          <span v-if="doctor && doctorQCReportserious != null" class="marr15">
            ({{ totalScoreserious.ReportScore }}分)
          </span>
          <span v-if="img && doctorQCImgserious != null">({{ totalScoreserious.ImageScore }}分)</span>
        </div>
        <div class="gradesCC" :style="{ height: height + 'px' }">
          <!-- 报告评分 -->
          <div v-if="gradeType == 'report'">
            <div class="content">
              <div :style="{ height: 'auto' }" class="flowAuto">
                <el-collapse v-model="activeNamesserious">
                  <el-collapse-item
                    title="严重扣分项"
                    name="1"
                    v-show="reportSpecialSIListserious && reportSpecialSIListserious.length > 0"
                  >
                    <div class="flowAuto" :style="{ maxHeight: height - 123 + 'px' }">
                      <div class="gradesCCs qcFrom">
                        <div class="gradesCCsTop marb12">
                          请选择严重扣分项原因（选择任一选项得0分)
                        </div>
                        <div v-for="(item, index) in reportSpecialSIListserious" :key="item.ScoreItemGuid">
                          <el-checkbox
                            v-model="checkListserious"
                            @change="checkboxChangeserious($event, index, 'report')"
                            :label="item"
                            class="marb10 block"
                            :disabled="isSeriousSubmintserious.flag"
                          >
                            {{ item.Description || "" }}
                          </el-checkbox>
                          <div class="gradesSelest" v-if="ischeckedserious[index]">
                            <el-input
                              v-model="item.Note"
                              type="textarea"
                              @blur="remarkBlurserious(item, index, 'report')"
                              :readonly="isSeriousSubmintserious.flag"
                              :class="item.notFilledIn ? 'bgImgSet' : ''"
                              placeholder="请输入扣分原因"
                            ></el-input>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-collapse-item>
                  <el-collapse-item title="基本扣分项" name="2">
                    <div class="flowAuto" :style="{ maxHeight: height - 123 + 'px' }">
                      <doctor-grade-list-serious
                        :obj="doctorQCReportserious"
                        @changeActiveNames="changeActiveNamesserious"
                      />
                      <div class="gradesRemark">
                        <el-form ref="form" class="gradesRemarkForm qcFrom">
                          <el-form-item label="备注">
                            <el-input
                              :readonly="isSubmintserious"
                              type="textarea"
                              v-model="remark.report"
                              placeholder="请输入内容"
                            ></el-input>
                          </el-form-item>
                          <el-form-item label="印象分">
                            <el-input
                              :readonly="isSubmintserious"
                              v-model.number="remark.reportNum"
                              placeholder="请输入印象分"
                              class="impression"
                            ></el-input>
                          </el-form-item>
                        </el-form>
                      </div>
                    </div>
                  </el-collapse-item>
                </el-collapse>
                <div class="submit" v-if="!specialFlag">
                  <el-button @click="createQCserious" type="success" size="small">提交</el-button>
                </div>
              </div>
            </div>
          </div>
          <!-- 影像评分 -->
          <div v-if="gradeType == 'img'">
            <div class="content">
              <div :style="{ height: 'auto' }" class="flowAuto">
                <el-collapse v-model="activeNamesserious">
                  <el-collapse-item
                    title="严重扣分项"
                    name="1"
                    v-show="imageSpecialSIListserious && imageSpecialSIListserious.length > 0"
                  >
                    <div class="flowAuto" :style="{ maxHeight: height - 123 + 'px' }">
                      <div class="gradesCCs qcFrom">
                        <div class="gradesCCsTop marb12">
                          请选择严重扣分项原因（选择任一选项得0分)
                        </div>
                        <div v-for="(item, index) in imageSpecialSIListserious" :key="item.ScoreItemGuid">
                          <el-checkbox
                            v-model="historycheckListserious"
                            @change="checkboxChangeserious($event, index, 'img')"
                            :label="item"
                            class="marb10 block"
                            :disabled="isSeriousSubmintserious.flag"
                          >
                            {{ item.Description || "" }}
                          </el-checkbox>
                          <div class="gradesSelest" v-if="imgischeckedserious[index]">
                            <el-input
                              v-model="item.Note"
                              type="textarea"
                              @blur="remarkBlurserious(item, index, 'img')"
                              :readonly="isSeriousSubmintserious.flag"
                              :class="item.notFilledIn ? 'bgImgSet' : ''"
                              placeholder="请输入扣分原因"
                            ></el-input>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-collapse-item>
                  <el-collapse-item title="基本扣分项" name="2">
                    <div class="flowAuto" :style="{ maxHeight: height - 123 + 'px' }">
                      <doctor-grade-list-serious
                        :obj="doctorQCImgserious"
                        @changeActiveNames="changeActiveNamesserious"
                      />
                      <div class="gradesRemark">
                        <el-form ref="form" class="gradesRemarkForm qcFrom">
                          <el-form-item label="备注">
                            <el-input
                              :readonly="isSubmintserious"
                              type="textarea"
                              v-model="remark.img"
                              placeholder="请输入内容"
                            ></el-input>
                          </el-form-item>
                          <el-form-item label="印象分">
                            <el-input
                              :readonly="isSubmintserious"
                              v-model.number="remark.imgNum"
                              placeholder="请输入印象分"
                              class="impression"
                            ></el-input>
                          </el-form-item>
                        </el-form>
                      </div>
                    </div>
                  </el-collapse-item>
                </el-collapse>
                <div class="submit" v-if="!specialFlag">
                  <el-button @click="createQCserious" type="success" size="small">提交</el-button>
                </div>
              </div>
            </div>
          </div>
          <!-- 病史评分 -->
          <div v-if="gradeType == 'history'">
            <div class="content">
              <div :style="{ height: 'auto' }" class="flowAuto">
                <el-collapse v-model="activeNamesserious">
                  <el-collapse-item
                    title="严重扣分项"
                    name="1"
                    v-show="imageSpecialSIListserious && imageSpecialSIListserious.length > 0"
                  >
                    <div class="flowAuto" :style="{ maxHeight: height - 123 + 'px' }">
                      <div class="gradesCCs qcFrom">
                        <div class="gradesCCsTop marb12">
                          请选择严重扣分项原因（选择任一选项得0分)
                        </div>
                        <div v-for="(item, index) in imageSpecialSIListserious" :key="item.ScoreItemGuid">
                          <el-checkbox
                            v-model="imgcheckListserious"
                            @change="checkboxChangeserious($event, index, 'img')"
                            :label="item"
                            class="marb10 block"
                            :disabled="isSeriousSubmintserious.flag"
                          >
                            {{ item.Description || "" }}
                          </el-checkbox>
                          <div class="gradesSelest" v-if="imgischeckedserious[index]">
                            <el-input
                              v-model="item.Note"
                              type="textarea"
                              @blur="remarkBlurserious(item, index, 'img')"
                              :readonly="isSeriousSubmintserious.flag"
                              :class="item.notFilledIn ? 'bgImgSet' : ''"
                              placeholder="请输入扣分原因"
                            ></el-input>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-collapse-item>
                  <el-collapse-item title="基本扣分项" name="2">
                    <div class="flowAuto" :style="{ maxHeight: height - 123 + 'px' }">
                      <doctor-grade-list-serious
                        :obj="doctorQCImgserious"
                        @changeActiveNames="changeActiveNamesserious"
                      />
                      <div class="gradesRemark">
                        <el-form ref="form" class="gradesRemarkForm qcFrom">
                          <el-form-item label="备注">
                            <el-input
                              :readonly="isSubmintserious"
                              type="textarea"
                              v-model="remark.img"
                              placeholder="请输入内容"
                            ></el-input>
                          </el-form-item>
                          <el-form-item label="印象分">
                            <el-input
                              :readonly="isSubmintserious"
                              v-model.number="remark.imgNum"
                              placeholder="请输入印象分"
                              class="impression"
                            ></el-input>
                          </el-form-item>
                        </el-form>
                      </div>
                    </div>
                  </el-collapse-item>
                </el-collapse>
                <div class="submit" v-if="!specialFlag">
                  <el-button @click="createQCserious" type="success" size="small">提交</el-button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Api from "../api/index.js";
import axios from "@/js/api";
import { cookieHandle } from "@/js/common";
import { mapState, mapActions, mapMutations } from "vuex";
import doctorGradeList from "./doctorGradeList";
import doctorGradeListSerious from "./doctorGradeListserious";

export default {
  data() {
    return {
      checkList: [],
      imgcheckList: [],
      historycheckList: [],
      maxHeight: `${document.documentElement.clientHeight - 4}`,
      height: 0,
      direction: "rtl",
      width: 0,
      appealList: [],
      fileList: [],
      appealListIndex: 0,
      dialogImageUrl: "",
      dialogVisible: false,
      appealScrollindex: 0,
      role: JSON.parse(localStorage.getItem("user")).roleName,
      doctor: false,
      img: false,
      imgType: true,
      dialogexpert: false,
      expertRow: {},
      dialogchoice: false,
      total: 0,
      flag: false,
      isShowTitle: true,
      ischecked: [],
      imgischecked: [],
      ischeckedhistory: [],
      activeNames: ["1", "2"],
      detailList: [],
      //是否严重扣分
      isSevere: false,
      specialFlag: true,
      //严重申诉的判断
      ischeckedserious: [],
      imgischeckedserious: [],
      activeNamesserious: ["1", "2"],
      checkListserious: [],
      imgcheckListserious: [],
      historycheckListserious: [],
      specialDrawer: false,
    };
  },
  components: {
    doctorGradeList,
    doctorGradeListSerious,
  },
  computed: {
    ...Vuex.mapState("breadcrumb", ["qcresultsShow", "loading", "localLoading"]),
    ...Vuex.mapState("managerPlanList", ["qcresultsByTaskList", "qcresultsList"]),
    ...Vuex.mapState("doctor", [
      //申诉严重扣分想项目
      "reportSpecialSIListserious",
      "imageSpecialSIListserious",
      "totalScoreserious",
      "doctorQCImgserious",
      "doctorQCReportserious",
      "remarkserious",
      "isSubmintserious",
      "isSubmintflagserious",
      "isSeriousSubmintserious",
      "appealLoading",
      "anyNoScoreImgserious",
      "anyNoScoreReportserious",
      "needNoteImgserious",
      "needNoteReportserious",
      // 其他
      "reportSpecialSIList",
      "imageSpecialSIList",
      "historySpecialSIList",
      "doctorQCHistory",
      "drawer",
      "appealInfo",
      "doctorQCReportIndex",
      "totalScore",
      "doctorQCImg",
      "doctorQCReport",
      "grade",
      "gradeIndex",
      "gradeType",
      "remark",
      "isSubmint",
      "reportDetails",
      "outerlayer",
      "needNoteImg",
      "needNoteReport",
      "anyNoScoreImg",
      "anyNoScoreReport",
      "anyNoScoreHistory",
      "needNoteHistory",
      "splitScreen",
      "appealDetail",
      "adminappealParameter",
      "appealExpertListParameter",
      "appealExpertList",
      "modifyShow",
      "respondShow",
      "isSeriousSubmint",
      "isSubmintflag",
      "doctorTaskStatus",
    ]),
  },
  watch: {
    gradeType(newValue, oldValue) {
      console.log("gradeType 变化了:", newValue);
      // 执行其他逻辑或处理
    },
  },
  activated() {
    this.$nextTick(() => {
      this.tabShow();
      this.ischecked = [];
      this.imgischecked = [];
      this.ischeckedhistory = [];
      this.ischeckedserious = [];
      this.imgischeckedserious = [];
      this.height = document.getElementsByClassName("doctorReport")[0].offsetHeight - 38;
      this.width = document.getElementsByClassName("doctorGrades")[0].offsetWidth + 28 + "px";
    });
    this.GetReportDetail().then((res) => {
      this.initDetail();
    });
  },
  created() {
    this.$nextTick(() => {
      this.tabShow();
      this.ischecked = [];
      this.imgischecked = [];
      this.historycheckList = [];
      this.ischeckedserious = [];
      this.imgischeckedserious = [];
      this.height = document.getElementsByClassName("doctorReport")[0].offsetHeight - 38;
      this.width = document.getElementsByClassName("doctorGrades")[0].offsetWidth + 28 + "px";
    });
    this.GetReportDetail().then((res) => {
      this.initDetail();
    });
  },
  methods: {
    ...Vuex.mapMutations("doctor", [
      "drawerShow",
      "setDetailsParameter",
      "setDetalLoading",
      "setGradeIndex",
      "setNeedNoteReport",
      "setNeedNoteImg",
      "setNeedNoteHistory",
      "getNeedNote",
      "setAnyNoScoreImg",
      "setAnyNoScoreReport",
      "setAnyNoScoreHistory",
      "getNoScore",
      "setLoading",
      "setlocalLoading",
      "resetappealDetail",
      "changerespondShow",
      "setSpecialList",
      "setIsSubmint",
      //申诉严重扣分项
      "setSpecialListserious",
      "setIsSubmintserious",
      "setAnyNoScoreImgserious",
      "setAnyNoScoreReportserious",
      "setAnyNoScoreHistoryserious",
      "setNeedNoteReportserious",
      "setNeedNoteHistoryserious",
      "getNoScoreserious",
      "setNeedNoteImgserious",
      "getNeedNoteserious",
    ]),
    ...Vuex.mapMutations("managerUser", ["currentChanges"]),
    ...Vuex.mapActions("doctor", [
      "QCAdminManageAppeal",
      "ManageAppeal",
      "CreateAppealInfo",
      "GetReportDetail",
      "CancelAppealInfo",
      "CreateOrUpdateQC",
      "SaveQCTmp",
      "GetAppealDetail",
      "DistributeAppeal",
      "GetAppealExpertList",
      "CheckAppeal",
      "AdmitAppeal",
      "GetReportDetailserious",
      //申诉严重扣分项
      "RescoreQcadminAppeal",
      "GetAppealRescoresDetailserious",
      "RescoreAppeal",
    ]),
    // 计算评分
    computedScore(type) {
      if (type == 'report' && this.doctor && this.doctorQCReport != null) {
        return this.totalScore.ReportScore;
      } else if (type == 'img' && this.img && this.doctorQCImg != null) {
        return this.totalScore.ImageScore;
      } else if (type == 'history' && this.history) {
        return this.totalScore.HistoryScore;
      }
    },
    // 提交申诉的修改
    specialCreateQC() {
      let scoreItems = this.gradeType == "report" ? this.doctorQCReportserious : this.doctorQCImgserious;
      let SpecialScoreItems =
        this.gradeType == "report" ? this.reportSpecialSIListserious : this.imageSpecialSIListserious;
      scoreItems = scoreItems.map((item) => {
        if (item.OptionGuid.length > 0) {
          item.OptionGuid = item.OptionGuid.join(",");
        } else {
          item.OptionGuid = "";
        }
        return item;
      });
      SpecialScoreItems = SpecialScoreItems.map((item) => {
        if (item.OptionGuid.length > 0) {
          item.OptionGuid = item.OptionGuid.join(",");
        } else {
          item.OptionGuid = "";
        }
        return item;
      });
      let par = {
        AppealInfoGuid: this.appealDetail.AppealInfoGuid,
        SamplingTaskGuid: this.qcresultsList.SamplingTaskGuid,
        ReportGuid: this.qcresultsList.ReportGuid,
        ExpertUserGuid: this.qcresultsList.expertUserId,
        Type: 0,
        IsSpecial: this.appealDetail.IsSpecial,
        Details: [],
        ScoreItems: scoreItems,
        SpecialScoreItems: SpecialScoreItems,
      };
      // console.log(JSON.stringify(par));
      if (this.role.contain("仲裁专家")) {
        // this.RescoreAppeal(par).then((res) => {
        //   ELEMENT.Message.success("修改成功");
        //   this.specialDrawer = false;
        //   this.appealDetail.IsSpecial = true;
        //   this.appealDetail.HasRescored = true;
        // });
        axios.ajaxPost("post", Api.api.experts.RescoreAppeal, par).then((res) => {
          ELEMENT.Message.success("修改成功");
          this.specialDrawer = false;
          this.appealDetail.IsSpecial = true;
          this.appealDetail.HasRescored = true;
        });
      } else {
        // this.RescoreQcadminAppeal(par).then((res) => {
        //   ELEMENT.Message.success("修改成功");
        //   this.specialDrawer = false;
        //   this.appealDetail.IsSpecial = true;
        //   this.appealDetail.HasRescored = true;
        // });
        axios.ajaxPost("post", Api.api.experts.RescoreQcadminAppeal, par).then((res) => {
          ELEMENT.Message.success("修改成功");
          this.specialDrawer = false;
          this.appealDetail.IsSpecial = true;
          this.appealDetail.HasRescored = true;
        });
      }
    },
    // 查看申诉的修改
    lookClick() {
      this.specialDrawer = !this.specialDrawer;
      this.specialFlag = true;
      this.setIsSubmintserious(true);
      this.GetAppealRescoresDetailserious({ appealInfoGuid: this.appealDetail.AppealInfoGuid }).then((res) => {
        this.initDetailserious(undefined, true);
      });
    },
    //申诉修改
    specialClick() {
      this.specialDrawer = !this.specialDrawer;
      this.specialFlag = false;
      this.GetReportDetailserious().then((res) => {
        this.initDetailserious(undefined, false);
      });
    },
    changeActiveNames(inittype) {
      let flag = 3;
      let type = "";
      if (inittype) {
        type = inittype;
      } else {
        type = this.gradeType;
      }
      if (type == "report") {
        for (let i = 0; i < this.doctorQCReport.length; i++) {
          if (this.doctorQCReport[i].Score != 500) {
            flag = 1;
            break;
          }
        }
        if (this.checkList.length > 0) {
          flag = 2;
        }
      } else if(type == "img"){
        for (let i = 0; i < this.doctorQCImg.length; i++) {
          if (this.doctorQCImg[i].Score != 500) {
            flag = 1;
            break;
          }
        }
        if (this.imgcheckList.length > 0) {
          flag = 2;
        }
      }else if(type == "history"){
        for (let i = 0; i < this.doctorQCHistory.length; i++) {
          if (this.doctorQCHistory[i].Score != 500) {
            flag = 1;
            break;
          }
        }
        if (this.historycheckList.length > 0) {
          flag = 2;
        }
      }
      if (flag == 1) {
        this.activeNames = ["2"];
      } else if (flag == 2) {
        this.activeNames = ["1"];
      } else {
        this.activeNames = ["1", "2",];
      }
    },
    initDetail(inittype) {
      let type = "";
      if (inittype) {
        type = inittype;
      } else {
        type = this.gradeType;
      }

      this.imgischecked = [];
      this.imgcheckList = [];
      this.historycheckList = [];
      if (type == "report") {
        this.ischecked = [];
        this.checkList = [];
        console.log("reportSpecialSIList",this.reportSpecialSIList);
        this.reportSpecialSIList.forEach((item, i) => {
          if (item.Score === item.TotalScore) {
            this.ischecked.push(true);
            this.checkList.push(this.reportSpecialSIList[i]);
          } else {
            this.ischecked.push(false);
          }
        });
        if (this.ischecked.indexOf(true) != -1) {
          // console.log("我来到了这里啦111111");
          this.setIsSubmint(true);
          if (this.role.contain("质控专家")) {
            this.isSeriousSubmint.flag = false;
          }
        }

        if (this.checkList.length > 0) {
          this.doctorQCReport.forEach((item) => {
            item.IsNoteShow = false;
          });
        }
      }
      if (type == "img") {
        console.log("imgcheckList在这里改变的",this.imageSpecialSIList);
        this.imageSpecialSIList.forEach((item, i) => {
          if (item.Score === item.TotalScore) {
            this.imgischecked.push(true);
            this.imgcheckList.push(this.imageSpecialSIList[i]);
          } else {
            this.imgischecked.push(false);
          }
        });
        // console.log(this.imgcheckList);
        if (this.imgischecked.indexOf(true) != -1) {
          // console.log("我来到了这里啦2222222");
          this.setIsSubmint(true);
          if (this.role.contain("质控专家")) {
            this.isSeriousSubmint.flag = false;
          }
        }
        if (this.imgcheckList.length > 0) {
          this.doctorQCImg.forEach((item) => {
            item.IsNoteShow = false;
          });
        }
      }
      if (type == "history") {
        this.historySpecialSIList.forEach((item, i) => {
          if (item.Score === item.TotalScore) {
            this.ischeckedhistory.push(true);
            this.historycheckList.push(this.historySpecialSIList[i]);
          } else {
            this.ischeckedhistory.push(false);
          }
        });
        if (this.ischeckedhistory.indexOf(true) != -1) {
          this.setIsSubmint(true);
          if (this.role.contain("质控专家")) {
            this.isSeriousSubmint.flag = false;
          }
        }
        if (this.historycheckList.length > 0) {
          this.doctorQCHistory.forEach((item) => {
            item.IsNoteShow = false;
          });
        }
      }
      if (this.isSubmintflag) {
        // console.log("我来到了这里啦333333");
        this.setIsSubmint(true);
        this.isSeriousSubmint.flag = true;
      }
      this.changeActiveNames();
    },
    checkboxChange(item, index, type) {
      let list = this.gradeType == "report" ? this.doctorQCReport : this.gradeType == "img" ? this.doctorQCImg : this.doctorQCHistory;
      let checkedType = type == "report" ? this.ischecked : type == "img" ? this.imgischecked : this.ischeckedhistory;
      let checkListType = type == "report" ? this.checkList : type == "img" ? this.imgcheckList : this.historycheckList;
      checkedType[index] = item;
      let flag = checkedType.indexOf(true) == -1 ? false : true;
      // console.log("我来到了这里啦444444");
      this.setIsSubmint(flag);
      this.isSeriousSubmint.flag = false;
      console.log(list);
      for (let j = 0; j < list.length; j++) {
        list[j].Score = 500;
        list[j].IsSerious = false;
      }
      this.activeNames = checkedType.indexOf(true) == -1 ? ["1", "2"] : ["1"];
      if (checkListType.length > 0) {
        this.setSpecialList({
          index: index,
          checked: item,
          flag: flag,
        });
      } else {
        this.setSpecialList({
          index: index,
          checked: item,
          flag: flag,
        });
        this.totalScore.ReportScore = flag ? 0 : 100;
      }
    },
    // 申诉严重扣分项逻辑
    checkboxChangeserious(item, index, type) {
      let list = this.gradeType == "report" ? this.doctorQCReportserious : this.doctorQCImgserious;
      let checkedType = type == "report" ? this.ischeckedserious : this.imgischeckedserious;
      let checkListType = type == "report" ? this.checkListserious : this.imgcheckListserious;
      checkedType[index] = item;
      let flag = checkedType.indexOf(true) == -1 ? false : true;
      this.setIsSubmintserious(flag);
      this.isSeriousSubmintserious.flag = false;
      for (let j = 0; j < list.length; j++) {
        list[j].Score = 500;
        list[j].IsSerious = false;
      }
      this.activeNamesserious = checkedType.indexOf(true) == -1 ? ["1", "2"] : ["1"];
      if (checkListType.length > 0) {
        this.setSpecialListserious({
          index: index,
          checked: item,
          flag: flag,
        });
      } else {
        this.setSpecialListserious({
          index: index,
          checked: item,
          flag: flag,
        });
        this.totalScoreserious.ReportScore = flag ? 0 : 100;
      }
    },
    // 严重扣分项逻辑
    changeActiveNamesserious(inittype) {
      let flag = 3;
      let type = "";
      if (inittype) {
        type = inittype;
      } else {
        type = this.gradeType;
      }
      if (type == "report") {
        for (let i = 0; i < this.doctorQCReportserious.length; i++) {
          if (this.doctorQCReportserious[i].Score != 500) {
            flag = 1;
            break;
          }
        }
        if (this.checkListserious.length > 0) {
          flag = 2;
        }
      } else {
        for (let i = 0; i < this.doctorQCImgserious.length; i++) {
          if (this.doctorQCImgserious[i].Score != 500) {
            flag = 1;
            break;
          }
        }
        if (this.imgcheckListserious.length > 0) {
          flag = 2;
        }
      }
      if (flag == 1) {
        this.activeNamesserious = ["2"];
      } else if (flag == 2) {
        this.activeNamesserious = ["1"];
      } else {
        this.activeNamesserious = ["1", "2"];
      }
    },
    // 申诉严重扣分项
    initDetailserious(inittype, flag) {
      let type = "";
      if (inittype) {
        type = inittype;
      } else {
        type = this.gradeType;
      }
      if (type == "report") {
        this.ischeckedserious = [];
        this.checkListserious = [];
        this.reportSpecialSIListserious.forEach((item, i) => {
          if (item.Score === item.TotalScore) {
            this.ischeckedserious.push(true);
            this.checkListserious.push(this.reportSpecialSIListserious[i]);
          } else {
            this.ischeckedserious.push(false);
          }
        });
        if (this.ischeckedserious.indexOf(true) != -1) {
          this.setIsSubmintserious(this.ischeckedserious.indexOf(true) != -1);
          this.isSeriousSubmintserious.flag = false;
        }

        if (this.checkListserious.length > 0) {
          this.doctorQCReportserious.forEach((item) => {
            item.IsNoteShow = false;
          });
        }
      }
      if (type == "img") {
        this.imgischeckedserious = [];
        this.imgcheckListserious = [];
        this.imageSpecialSIListserious.forEach((item, i) => {
          if (item.Score === item.TotalScore) {
            this.imgischeckedserious.push(true);
            this.imgcheckListserious.push(this.imageSpecialSIListserious[i]);
          } else {
            this.imgischeckedserious.push(false);
          }
        });
        if (this.imgischeckedserious.indexOf(true) != -1) {
          this.setIsSubmintserious(true);
          if (this.role.contain("质控专家")) {
            this.isSeriousSubmintserious.flag = false;
          }
        }
        if (this.imgcheckListserious.length > 0) {
          this.doctorQCImgserious.forEach((item) => {
            item.IsNoteShow = false;
          });
        }
      }
      if (this.isSubmintflagserious) {
        this.setIsSubmintserious(true);
        this.isSeriousSubmintserious.flag = true;
      }
      this.changeActiveNamesserious();
    },
    choice(row) {
      this.dialogexpert = false;
      this.dialogchoice = true;
      this.expertRow = row;
    },
    dialogchoiceClick(type) {
      if (type) {
        this.dialogexpert = true;
        this.dialogchoice = false;
      } else {
        this.dialogchoice = false;
        this.expertRow.AppealInfoGuid = this.appealDetail.AppealInfoGuid;
        this.expertRow.ExpertUserGuid = this.expertRow.UserGuid;
        this.DistributeAppeal(this.expertRow).then((_) => {
          this.drawerShow(false);
        });
      }
    },
    search() {
      this.appealExpertListParameter.PageIndex = 1;
      this.GetAppealExpertList();
    },
    currentChange(val) {
      this.appealExpertListParameter.PageIndex = val;
      this.GetAppealExpertList();
    },
    getappealIndex(index) {
      let arg = arguments[1];
      if (arg) {
        this.imgType = false;
      } else {
        this.imgType = true;
      }
      this.appealListIndex = index;
    },
    handleManagerOptionGuid(res) {
      if (typeof res.ManagerOptionGuid === "string") {
        return res.ManagerOptionGuid;
      } else {
        return res.ManagerOptionGuid.join(","); // 使用逗号分隔转换为字符串
      }
    },
    // 仲裁管理员直接处理
    respond(type) {
      let details = [],
        _this = this,
        confirmtext = "审核";
      this.appealDetail.Details.forEach((res) => {
        details.push({
          ManagerOptionGuid: _this.handleManagerOptionGuid(res),
          ManagerScore: res.ManagerScore,
          ManagerResponse: res.ManagerResponse,
          ManagerResponsePicUrls: res.imageList.join(","),
          ScoreItemGuid: res.ScoreItemGuid,
        });
      });
      this.verification();
      if (type == "direct") {
        confirmtext = "回应";
      }
      if (this.flag) {
        _this
          .$confirm(`报告${confirmtext}后将不能做任何操作(包括撤回)，确定${confirmtext}报告吗？`, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          })
          .then(() => {
            if (type == "direct") {
              let arr = {
                AppealInfoGuid: _this.appealDetail.AppealInfoGuid,
                Details: details,
              };
              // console.log(JSON.stringify(arr));
              // 仲裁管理员直接回应
              _this
                .QCAdminManageAppeal({
                  AppealInfoGuid: _this.appealDetail.AppealInfoGuid,
                  Details: details,
                })
                .then((_) => {
                  _this.GetReportDetail().then((res) => {
                    _this.initDetail();
                  });
                  _this.drawerShow(false);
                });
            } else {
              // 仲裁管理员审核
              _this
                .CheckAppeal({
                  AppealInfoGuid: _this.appealDetail.AppealInfoGuid,
                  Details: details,
                })
                .then((_) => {
                  _this.GetReportDetail();
                  _this.drawerShow(false);
                });
            }
          })
          .catch((err) => {
            _this.$message({
              type: "info",
              message: `已取消${confirmtext}`,
            });
          });
      }
    },
    // 仲裁专家回应
    expertRespond() {
      let details = [];
      let _this = this;
      this.appealDetail.Details.forEach((res) => {
        let ExpertOptionGuid = !res.Ismodify ? res.RawOptionGuid : res.ManagerOptionGuid.join(",");
        console.log(ExpertOptionGuid);
        details.push({
          ExpertOptionGuid: ExpertOptionGuid,
          ExpertScore: res.ManagerScore,
          ExpertResponse: res.ManagerResponse,
          ExpertResponsePicUrls: res.imageList.join(","),
          ScoreItemGuid: res.ScoreItemGuid,
        });
      });
      this.verification();
      if (this.flag) {
        _this
          .$confirm("确定回应报告吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          })
          .then(() => {
            _this
              .ManageAppeal({
                AppealInfoGuid: _this.appealDetail.AppealInfoGuid,
                Details: details,
              })
              .then((_) => {
                _this.drawerShow(false);
              });
          })
          .catch((err) => {
            _this.$message({
              type: "info",
              message: "已取消回应",
            });
          });
      }
    },
    verification() {
      for (let i = 0; i < this.appealDetail.Details.length; i++) {
        if (
          this.appealDetail.Details[i].ManagerResponse == "" ||
          this.appealDetail.Details[i].ManagerResponse == null
        ) {
          this.appealDetail.Details[i].notFilledIn = true;
          this.$message({
            message: "请输入回应内容!",
            type: "warning",
          });
          this.flag = false;
        } else {
          this.flag = true;
        }
      }
    },
    radioClick(index, objindex, items, item) {
      let totalScore = 0; // 重置总分
      let fatherTotalScore = item.MaxScore;
      item.ManagerOptionGuid.forEach((guid) => {
        const selectedItem = item.Options.find((item) => item.OptionGuid === guid);
        if (selectedItem) {
          totalScore += selectedItem.Score;
        }
      });
      if (totalScore >= fatherTotalScore) {
        totalScore = fatherTotalScore;
      }
      this.appealDetail.Details[index].ManagerScore = totalScore;
    },
    compentedScore() {},
    tabShow() {
      if (this.role.contain("医生")) {
        this.doctor = true;
        this.img = false;
        this.history = false;
      } else if (this.role.contain("技师")) {
        this.img = true;
        this.doctor = false;
      } else if (this.role.contain("仲裁管理") || this.role.contain("仲裁专家")) {
        this.changerespondShow(true);
        if (this.adminappealParameter.type == 2) {
          this.doctor = true;
          this.img = false;
          this.history = false;
        }
        if (this.adminappealParameter.type == 3) {
          this.doctor = false;
          this.img = true;
          this.history = false;
        }
      } else {
        this.img = true;
        this.doctor = true;
        this.history = true
        this.changerespondShow(false);
      }
    },
    // 确认申诉
    determine() {
      let _this = this;
      _this
        .$confirm("确认以上申诉的反馈结果吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
        .then(() => {
          _this
            .AdmitAppeal({
              AppealInfoGuid: this.qcresultsList.AppealInfoGuid,
            })
            .then((res) => {
              _this.drawerShow(false);
            });
        })
        .catch((err) => {
          _this.$message({
            type: "info",
            message: "已取消确认",
          });
        });
    },
    // 取消申诉
    withdraw() {
      let _this = this;
      _this
        .$confirm("是否确定撤回该条申诉报告？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
        .then(() => {
          _this
            .CancelAppealInfo({
              AppealInfoGuid: this.qcresultsList.AppealInfoGuid,
            })
            .then((res) => {
              _this.drawerShow(false);
              if (this.role.contain("医生")) {
                this.totalScore.CanReportAppeal = true;
                this.totalScore.IsShowReportAppealBtn = false;
              } else {
                this.totalScore.CanImageAppeal = true;
                this.totalScore.IsShowImageAppealBtn = false;
              }
            });
        })
        .catch((err) => {
          _this.$message({
            type: "info",
            message: "已取消撤回",
          });
        });
    },
    // 提交申诉
    subBtn() {
      let details = [];
      this.appealList.forEach((res) => {
        if (res.checked) {
          details.push({
            ScoreItemGuid: res.ScoreItemGuid,
            RawOptionGuid: res.OptionGuid.join(","),
            RawScore: res.Score,
            Request: res.desc,
            RequestPicUrls: res.imageList.join(","),
          });
        }
      });
      if (details.length == 0) {
        this.$message({
          message: "至少选择一条申诉内容哦!",
          type: "warning",
        });
        return false;
      } else {
        for (let i = 0; i < this.appealList.length; i++) {
          if (this.appealList[i].checked && this.appealList[i].desc == "") {
            this.appealList[i].notFilledIn = true;
            this.appealScrollindex = i;
            this.$message({
              message: "需要填写申诉原因哦!",
              type: "warning",
            });
            this.setAppealScroll();
            return false;
          }
        }
      }
      this.CreateAppealInfo({
        SamplingTaskGuid: this.qcresultsList.SamplingTaskGuid,
        ReportGuid: this.qcresultsList.ReportGuid,
        ExpertUserGuid: this.qcresultsList.expertUserId,
        Type: this.role.contain("技师") ? 3 : this.role.contain("诊断医生") ? 4 : 2,
        Details: details,
        IsSpecial: this.isSevere,
      }).then((res) => {
        if (this.role.contain("医生")) {
          this.totalScore.CanReportAppeal = false;
          this.totalScore.IsShowReportAppealBtn = true;
        } else {
          this.totalScore.CanImageAppeal = false;
          this.totalScore.IsShowImageAppealBtn = true;
        }
      });
    },
    // 转发
    forward() {
      this.dialogexpert = true;
      this.appealExpertListParameter.Keyword = "";
      this.GetAppealExpertList();
    },
    setAppealScroll() {
      this.$nextTick(() => {
        let eleNode = document.getElementsByClassName("appealItem")[this.appealScrollindex];
        eleNode.parentNode.parentNode.parentNode.scrollTop =
          eleNode.offsetTop - eleNode.parentNode.parentNode.parentNode.offsetTop - 85;
      });
    },
    // 发起申诉
    appealLaunch(tabState, state) {
      this.isShowTitle = false;
      let objList = [];
      let specialSIList = [];
      if (tabState == "report") {
        objList = this.doctorQCReport;
        specialSIList = this.reportSpecialSIList;
        // console.log(JSON.stringify(objList));
        // console.log(specialSIList);
      }
      if (tabState == "img") {
        objList = this.doctorQCImg;
        specialSIList = this.imageSpecialSIList;
      }
      this.resetappealDetail();
      this.drawerShow(true);
      this.appealList = [];
      let objArr = [];
      objList.forEach((res) => {
        if (res.Score !== 500 && res.Score !== 0) {
          res.imageList = [];
          res.checked = false;
          res.desc = "";
          res.notFilledIn = false;
          objArr.push(JSON.parse(JSON.stringify(res)));
        }
      });
      if (objArr.length === 0) {
        this.isSevere = true;
        specialSIList.forEach((res) => {
          if (res.Score !== 500) {
            res.imageList = [];
            res.checked = false;
            res.desc = "";
            res.notFilledIn = false;
            objArr.push(JSON.parse(JSON.stringify(res)));
          }
        });
      } else {
        this.isSevere = false;
      }
      this.appealList = objArr;
    },
    // 查看申诉
    appealDetails() {
      const { gradeIndex, qcresultsList, drawerShow, GetAppealDetail, role, appealDetail } = this;
      drawerShow(true);
      this.appealList = [];
      GetAppealDetail({
        SamplingTaskGuid: qcresultsList.SamplingTaskGuid,
        ReportGuid: qcresultsList.ReportGuid,
        ExpertUserGuid: qcresultsList.expertUserId,
        Type: gradeIndex == 0 ? 2 : 3,
      }).then((_) => {
        let index = 0;
        let changeClass = document.getElementsByClassName("el-timeline-item__node");
        let appealDetail = this.appealDetail.StatusList;
        this.qcresultsList.AppealInfoGuid = this.appealDetail.AppealInfoGuid;
        for (let i = 0; i < appealDetail.length; i++) {
          if (appealDetail[i].DateTime != "") {
            index = i;
            changeClass[i].parentNode.firstChild.classList.add("borderLeft");
          } else {
            changeClass[i].parentNode.firstChild.classList.remove("borderLeft");
          }
        }
        changeClass[index].parentNode.firstChild.classList.remove("borderLeft");
      });
    },
    noteBlurs(item, index) {
      this.appealList[index].notFilledIn = false;
      this.$forceUpdate();
    },
    detilnoteBlurs(item, index) {
      this.appealDetail.Details[index].notFilledIn = false;
      this.$forceUpdate();
    },
    // 抽屉关闭
    handleClose(done) {
      this.drawerShow(false);
    },
    deleteImg(index, imgindex) {
      this.appealList[index].imageList.splice(imgindex, 1);
      this.$forceUpdate();
    },
    detildeleteImg(index, imgindex) {
      this.appealDetail.Details[index].imageList.splice(imgindex, 1);
      this.$forceUpdate();
    },
    // 点击放大功能
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file;
      this.dialogVisible = true;
    },
    getFile(file, fileList) {
      this.getBase64(file.raw).then((res) => {
        const params = res.split(",");
        if (params.length > 0) {
          this.proofImage = params[1];
          let Formdata = new FormData();
          let fname = file.name.toUpperCase();
          let pos = fname.indexOf(".");
          //获取医生列表
          axios
            .ajaxPost("post", Api.api.specialist.UploadPic, {
              ImageBase64: this.proofImage,
              ImageFormat: fname.substr(pos + 1),
            })
            .then((res) => {
              if (res.data.StatusCode == 200) {
                if (this.imgType) {
                  this.appealList[this.appealListIndex].imageList.push(res.data.ImageUrl);
                } else {
                  this.appealDetail.Details[this.appealListIndex].imageList.push(res.data.ImageUrl);
                }
                this.$forceUpdate();
              }
            });
        }
      });
    },
    handleUploadRemove(file, fileList) {
      this.proofImage = "";
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 1;
      let fname = file.name.toUpperCase();
      if (fname.match("JPG|PNG|JPEG") == null) {
        this.$message.error("上传图片需要JPG或者PNG格式!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 1MB!");
      }
      return isLt2M;
    },
    // handleAvatarSuccess(res, file) {},
    handleError(err, rawFile) {
      // this.$message.error('图片上传错误');
    },
    qcresultsChange(val) {
      let _this = this;
      this.setDetalLoading(true);
      this.qcresultsByTaskList.filter((item) => {
        if (val == item.Name) {
          _this.setDetailsParameter({
            reportGuid: _this.qcresultsList.ReportGuid,
            samplingTaskGuid: _this.qcresultsList.SamplingTaskGuid,
            ExpertUserGuid: item.ExpertUserId,
          });
          return item;
        }
      });
      this.GetReportDetail();
    },
    tabNav(index, type) {
      if (this.isSubmintflag) {
        this.initDetail(type);
      } else {
        if (this.doctorTaskStatus != 123) {
          this.initDetail(type);
        }
      }
      this.changeActiveNames(type);
      if (this.role.contain("质控专家")) {
        if (type == "report") {
          if (this.checkList.length == 0) {
            this.setIsSubmint(false);
          } else {
            this.setIsSubmint(true);
          }
        } else {
          // console.log("我来到了这里啦55555");
          // console.log(this.imgcheckList);
          if (this.imgcheckList.length == 0) {
            this.setIsSubmint(false);
          } else {
            this.setIsSubmint(true);
          }
        }
        this.isSeriousSubmint.flag = false;
      }
      if (this.isSubmintflag) {
        this.setIsSubmint(true);
        this.isSeriousSubmint.flag = true;
      }
      this.setGradeIndex({
        index: index,
        type: type,
      });
    },
    //暂存
    saveTmp() {
      this.setAnyNoScoreImg(false);
      this.setAnyNoScoreReport(false);
      this.setAnyNoScoreHistory(false);
      this.getNoScore();
      this.setLoading(true);
      this.SaveQCTmp();
    },
    offsetposition(index, type) {
      this.setGradeIndex({
        index: index,
        type: type,
      });
      if (this.role.contain("质控专家")) {
        // console.log("我来到了这里啦666666");
        if (type == "report") {
          if (this.checkList.length == 0) {
            this.setIsSubmint(false);
          } else {
            this.setIsSubmint(true);
          }
        } else if (type == "img") {
          if (this.imgcheckList.length == 0) {
            this.setIsSubmint(false);
          } else {
            this.setIsSubmint(true);
          }
        } else if (type == "history") {
          if (this.historycheckList.length == 0) {
            this.setIsSubmint(false);
          } else {
            this.setIsSubmint(true);
          }
        }
        this.isSeriousSubmint.flag = false;
      }
      this.$nextTick(() => {
        let eleNode = document.getElementsByClassName("gradesCCs")[this.doctorQCReportIndex];
        eleNode.parentNode.parentNode.scrollTop = eleNode.offsetTop - eleNode.parentNode.parentNode.offsetTop;
      });
    },
    // 严重扣分项申诉修改的时候的滚动条
    offsetpositionserious(index, type) {
      // this.setGradeIndex({
      // 	index: index,
      // 	type: type
      // });
      if (this.role.contain("质控专家")) {
        if (type == "report") {
          if (this.checkListserious.length == 0) {
            this.setIsSubmintseriou(false);
          } else {
            this.setIsSubmintseriou(true);
          }
        } else {
          if (this.imgcheckListserious.length == 0) {
            this.setIsSubmintseriou(false);
          } else {
            this.setIsSubmintseriou(true);
          }
        }
        this.isSeriousSubmintserious.flag = false;
      }
      // this.$nextTick(() => {
      // 	let eleNode = document.getElementsByClassName('gradesCCs')[this.doctorQCReportIndexserious];
      // 	eleNode.parentNode.parentNode.scrollTop = eleNode.offsetTop - eleNode.parentNode.parentNode
      // 		.offsetTop;
      // });
    },
    remarkBlur(item, index, type) {
      if (item.Note !== "") {
        if (type == "report") {
          this.reportSpecialSIList[index].notFilledIn = false;
        } else {
          this.imageSpecialSIList[index].notFilledIn = false;
        }
        this.$forceUpdate();
      }
    },
    // 严重扣分项申诉
    remarkBlurserious(item, index, type) {
      if (item.Note !== "") {
        if (type == "report") {
          this.reportSpecialSIListserious[index].notFilledIn = false;
        } else {
          this.imageSpecialSIListserious[index].notFilledIn = false;
        }
        this.$forceUpdate();
      }
    },
    //严重扣分项修改时候的提交
    createQCserious() {
      // console.log(222);
      this.setNeedNoteReportserious(false);
      this.setNeedNoteImgserious(false);
      this.setNeedNoteHistoryserious(false);

      this.setAnyNoScoreReportserious(false);
      this.setAnyNoScoreImgserious(false);
      this.setAnyNoScoreHistoryserious(false);
      this.getNoScoreserious();
      let specialFlag = true;
      let checkedTypeserious = this.gradeType == "report" ? this.ischeckedserious : this.imgischeckedserious;
      let index = checkedTypeserious.indexOf(true);
      // 报告
      if (this.checkListserious.length > 0) {
        for (let i = 0; i < this.reportSpecialSIListserious.length; i++) {
          if (checkedTypeserious[i]) {
            if (
              this.reportSpecialSIListserious[i].Score != 0 &&
              this.reportSpecialSIListserious[i].Score != 500 &&
              (this.reportSpecialSIListserious[i].Note == null || this.reportSpecialSIListserious[i].Note == "")
            ) {
              this.reportSpecialSIListserious[i].notFilledIn = true;
              this.offsetpositionserious(0, "report");
              this.$message({
                message: "请填写严重扣分报告评分原因",
                type: "warning",
              });
              return false;
            }
          }
        }
      } else {
        console.log(3333);
        if (this.anyNoScoreReportserious) {
          this.offsetpositionserious(0, "report");
          this.$message({
            message: "报告评分每项都要评哦。",
            type: "warning",
          });
          return false;
        }
        this.getNeedNoteserious();
        if (this.needNoteReportserious) {
          this.offsetpositionserious(0, "report");
          this.$message({
            message: "请完善报告评分原因信息。",
            type: "warning",
          });
          return false;
        }
      }
      // 影像
      if (this.imgcheckListserious.length > 0) {
        for (let i = 0; i < this.imageSpecialSIListserious.length; i++) {
          if (checkedTypeserious[i]) {
            if (
              this.imageSpecialSIListserious[i].Score != 0 &&
              this.imageSpecialSIListserious[i].Score != 500 &&
              (this.imageSpecialSIListserious[i].Note == null || this.imageSpecialSIListserious[i].Note == "")
            ) {
              this.imageSpecialSIListserious[i].notFilledIn = true;
              this.offsetpositionserious(1, "img");
              this.$message({
                message: "请填写严重扣分影像评分原因",
                type: "warning",
              });
              return false;
            }
          }
        }
      }
      // 病史
      if (this.historycheckListserious.length > 0) {
        for (let i = 0; i < this.historySpecialSIListserious.length; i++) {
          if (checkedTypeserious[i]) {
            if (this.historySpecialSIListserious[i].Score != 0 && this.historySpecialSIListserious[i].Score != 500 && (this.historySpecialSIListserious[i].Note == null || this.historySpecialSIListserious[i].Note == "")) {
              this.historySpecialSIListserious[i].notFilledIn = true;
              this.offsetpositionserious(2, "history");
              this.$message({
                message: "请填写严重扣分病史评分原因",
                type: "warning",
              });
              return false;
            }
          }
        }
      }
      // else {
      // 	if (this.anyNoScoreImgserious) {
      // 		this.offsetpositionserious(1, 'img');
      // 		this.$message({
      // 			message: '影像评分每项都要评哦。',
      // 			type: 'warning'
      // 		});
      // 		return false;
      // 	}
      // 	this.getNeedNoteserious();
      // 	if (this.needNoteImgserious) {
      // 		this.offsetpositionserious(1, 'img');
      // 		this.$message({
      // 			message: '请完善影像评分原因信息。',
      // 			type: 'warning'
      // 		});
      // 		return false;
      // 	}
      // }
      this.specialCreateQC();
    },
    //提交
    createQC() {
      this.setNeedNoteReport(false);
      this.setNeedNoteImg(false);
      this.setNeedNoteHistory(false);
      this.setAnyNoScoreReport(false);
      this.setAnyNoScoreImg(false);
      this.setAnyNoScoreHistory(false);
      this.getNoScore();
      let specialFlag = true;
      let checkedType = this.gradeType == "report" ? this.ischecked : this.imgischecked;
      let index = checkedType.indexOf(true);
      // this.totalScore.Category;
      let flag = true;
      if (this.totalScore.Category == 2 || this.totalScore.Category == 3 || this.totalScore.Category == 4 || this.reportDetails.Kind === 2) {
        // 报告
        if (this.checkList.length > 0) {
          for (let i = 0; i < this.reportSpecialSIList.length; i++) {
            if (checkedType[i]) {
              if (
                this.reportSpecialSIList[i].Score != 0 &&
                this.reportSpecialSIList[i].Score != 500 &&
                (this.reportSpecialSIList[i].Note == null || this.reportSpecialSIList[i].Note == "")
              ) {
                this.reportSpecialSIList[i].notFilledIn = true;
                this.offsetposition(0, "report");
                this.$message({
                  message: "请填写严重扣分报告评分原因",
                  type: "warning",
                });
                flag = false;
                return false
              }
            }
          }
        } else {
          console.log(1111);
          if (this.anyNoScoreReport) {
            this.offsetposition(0, "report");
            this.$message({
              message: "报告评分每项都要评哦。",
              type: "warning",
            });
            flag = false;
            return false
          }
          this.getNeedNote();
          if (this.needNoteReport) {
            this.offsetposition(0, "report");
            this.$message({
              message: "请完善报告评分原因信息。",
              type: "warning",
            });
            flag = false;
            return false;
          }
        }
      }
      if (this.totalScore.Category == 1 || this.totalScore.Category == 3 || this.totalScore.Category == 4 || this.reportDetails.Kind === 2) {
        // 影像
        if (this.imgcheckList.length > 0) {
          for (let i = 0; i < this.imageSpecialSIList.length; i++) {
            if (checkedType[i]) {
              if (
                this.imageSpecialSIList[i].Score != 0 &&
                this.imageSpecialSIList[i].Score != 500 &&
                (this.imageSpecialSIList[i].Note == null || this.imageSpecialSIList[i].Note == "")
              ) {
                this.imageSpecialSIList[i].notFilledIn = true;
                this.offsetposition(1, "img");
                this.$message({
                  message: "请填写严重扣分影像评分原因",
                  type: "warning",
                });
                flag = false;
                return false;
              }
            }
          }
        } else {
          if (this.anyNoScoreImg) {
            this.offsetposition(1, "img");
            this.$message({
              message: "影像评分每项都要评哦。",
              type: "warning",
            });
            flag = false;
            return false;
          }
          this.getNeedNote();
          if (this.needNoteImg) {
            this.offsetposition(1, "img");
            this.$message({
              message: "请完善影像评分原因信息。",
              type: "warning",
            });
            flag = false;
            return false;
          }
        }
      }
      if (this.totalScore.Category == 4 || this.reportDetails.Kind === 2) {
        // 病史
        if (this.historycheckList.length > 0) {
          for (let i = 0; i < this.historySpecialSIList.length; i++) {
            if (checkedType[i]) {
              if (
                this.historySpecialSIList[i].Score != 0 &&
                this.historySpecialSIList[i].Score != 500 &&
                (this.historySpecialSIList[i].Note == null || this.historySpecialSIList[i].Note == "")
              ) {
                this.historySpecialSIList[i].notFilledIn = true;
                this.offsetposition(2, "history");
                this.$message({
                  message: "请填写严重扣分病史评分原因",
                  type: "warning",
                });
                flag = false;
                return false;
              }
            }
          }
        } else {
          if (this.anyNoScoreHistory) {
            this.offsetposition(2, "history");
            this.$message({
              message: "病史评分每项都要评哦。",
              type: "warning",
            });
            flag = false;
            return false;
          }
          this.getNeedNote();
          if (this.needNoteHistory) {
            this.offsetposition(2, "history");
            this.$message({
              message: "请完善病史评分原因信息。",
              type: "warning",
            });
            flag = false;
            return false;
          }
        }
      }
      console.log(flag,'flagflagflag');
      if (flag) {
        this.setLoading(true);
        this.CreateOrUpdateQC();
      }else{
        flag = true
      }
    },
  },
};
</script>
<style type="text/css" scoped="scoped">
.el-drawer__body .title {
  padding-left: 20px;
}
.doctorPage .doctorGrades .gradesCC .title {
  padding: 0 26px 15px !important;
}

.doctorPage .doctorGrades .gradesCC .content {
  padding: 0;
}
.el-collapse-item {
  margin: 0 17px 20px !important;
  padding: 10px 14px;
  box-sizing: border-box;
  border: 1px solid #4d505a;
  border-radius: 8px;
}

.content >>> .el-icon-arrow-right:before {
  content: "\e78f";
}

.content >>> .el-collapse-item__content {
  padding-bottom: 0 !important;
}

.content >>> .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
  background-color: #409eff !important;
  border-color: #409eff !important;
}
</style>
